import { Injectable } from '@angular/core';
import { LogService } from '../../../shared/services/log.service';
import { ToastService } from '../../../shared/services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '../../../shared/services/account.service';
import { RedirectService } from '../../../shared/services/redirect.service';
import { Angulartics2Facebook } from 'angulartics2/facebook';
import { take } from 'rxjs/operators';
import { AnalyticsTrackingProvider, AuthService } from '@yotpo-ui/core';

@Injectable()
export class ProductEffectsService {

  constructor(private logger: LogService,
    private toastrService: ToastService,
    private translate: TranslateService,
    private accountService: AccountService,
    private redirectService: RedirectService,
    private authService: AuthService,
    private redCrossService: AnalyticsTrackingProvider,
    private fbAnalytics: Angulartics2Facebook,

  ) { }

  updateProduct(product) {
    let params = {
      category: product.product,
      store_info: {},
      action_params: { context: 'signup' }
  };
    params['store_info']['app_key'] = this.authService.getCredentials().appKey;
    this.accountService.enable_product(params).pipe(take(1)).subscribe(
      (response: any) => {
        if (response.status.redirect_url && (response.response.store_info.app_key && response.response.admin_info.token)) {
          this.redCrossService.track('Signup Completed');
          this.fbAnalytics.eventTrack('CompleteRegistration');
          this.redirectService.navigateOrRedirectTo(new URL(response.status.redirect_url));
        } else {
          this.handleError(response);
        }
      }, response => {
        this.handleError(response);
      });
  }


  private handleError(response) {
    this.logger.error(response);
    let errMsg = this.translate.instant('SIGNUP.PRODUCT.SAVE_FAILED');
    this.toastrService.error('signup', 'ProductEffectsService: updateProduct', errMsg, response);
  }
}
